import { Icon } from '@iconify/react';
import React from 'react';

export default function ContactInfoWidget() {
  return (
    <div className="grid grid-cols-1 gap-4">
      <div>
        <ul className="space-y-4 m-0 p-0 list-none">
          <li className="flex items-start gap-3">
            <span className="w-8 h-8 rounded-full bg-crimson/10 text-crimson flex items-center justify-center shrink-0 mt-1 transition-colors hover:bg-crimson hover:text-white">
              <Icon icon="ep:location" className="text-lg" />
            </span>
            <div className="text-[0.9rem] font-light text-charcoal/80 leading-relaxed">
              <strong className="font-medium text-charcoal block mb-0.5">Office:</strong> 
              First Floor, Sterling Bank Plaza, Central Business District, Abuja, 900103
            </div>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-8 h-8 rounded-full bg-crimson/10 text-crimson flex items-center justify-center shrink-0 mt-1 transition-colors hover:bg-crimson hover:text-white">
              <Icon icon="fluent:call-24-regular" className="text-lg" />
            </span>
            <div className="text-[0.9rem] font-light text-charcoal/80 leading-relaxed">
              <strong className="font-medium text-charcoal block mb-0.5">Phone:</strong> 
              +234 803 873 8245
            </div>
          </li>
          <li className="flex items-start gap-3">
            <span className="w-8 h-8 rounded-full bg-crimson/10 text-crimson flex items-center justify-center shrink-0 mt-1 transition-colors hover:bg-crimson hover:text-white">
              <Icon icon="bi:envelope" className="text-lg" />
            </span>
            <div className="text-[0.9rem] font-light text-charcoal/80 leading-relaxed">
              <strong className="font-medium text-charcoal block mb-0.5">Email:</strong> 
              contact@nooohraservices.org
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
